// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import * as PassagesAPI from "./passages.mjs";
import { Passages, } from "./passages.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { buildHeaders } from "../../internal/headers.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Archives extends APIResource {
    constructor() {
        super(...arguments);
        this.passages = new PassagesAPI.Passages(this._client);
    }
    /**
     * Create a new archive.
     */
    create(body, options) {
        return this._client.post('/v1/archives/', { body, ...options });
    }
    /**
     * Get a single archive by its ID.
     */
    retrieve(archiveID, options) {
        return this._client.get(path `/v1/archives/${archiveID}`, options);
    }
    /**
     * Update an existing archive's name and/or description.
     */
    update(archiveID, body, options) {
        return this._client.patch(path `/v1/archives/${archiveID}`, { body, ...options });
    }
    /**
     * Get a list of all archives for the current organization with optional filters
     * and pagination.
     */
    list(query = {}, options) {
        return this._client.getAPIList('/v1/archives/', (ArrayPage), { query, ...options });
    }
    /**
     * Delete an archive by its ID.
     */
    delete(archiveID, options) {
        return this._client.delete(path `/v1/archives/${archiveID}`, {
            ...options,
            headers: buildHeaders([{ Accept: '*/*' }, options?.headers]),
        });
    }
}
Archives.Passages = Passages;
//# sourceMappingURL=archives.mjs.map